;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();export default function AcademyOnboarding() {
  return (
    <svg width="131" height="124" viewBox="0 0 131 124" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M40.4607 38.27C26.5498 38.27 15.4111 45.8 15.4111 55.01V85.71"
        stroke="#64348C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.4606 29.9C46.9424 29.9 51.5894 25.34 51.5894 18.74V13.16C51.5894 6.56003 46.9424 2 40.4606 2C33.9788 2 29.3319 6.56003 29.3319 13.16V18.74C29.3319 25.35 33.9788 29.9 40.4606 29.9Z"
        stroke="#64348C"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path d="M26.5395 57.8101V85.7201" stroke="#64348C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M40.4603 38.27C54.3712 38.27 65.5099 45.8 65.5099 55.01V74.54C65.5099 80.7 60.5239 85.7 54.3812 85.7"
        stroke="#64348C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M54.3714 57.8101V122" stroke="#64348C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M26.5395 110.83V122" stroke="#64348C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M43.2425 85.7197V122" stroke="#64348C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M32.114 85.7197H1.5V110.84H32.114V85.7197Z" stroke="#64348C" strokeWidth="3" strokeLinejoin="round" />
      <path
        d="M107.243 41.0698L90.5495 57.8098L82.203 49.4398L73.8465 57.8098L90.5495 74.5498L115.589 49.4398L107.243 41.0698Z"
        stroke="#A7DADB"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M60.6735 35.5098C67.4146 25.3998 78.9022 18.7397 91.9356 18.7397C112.687 18.7397 129.5 35.6098 129.5 56.4098C129.5 77.2098 112.677 94.0798 91.9356 94.0798C83.3597 94.0798 75.4619 91.1997 69.1397 86.3597"
        stroke="#64348C"
        strokeWidth="3"
        strokeLinejoin="round"
      />
    </svg>
  );
}
